// web/src/features/profile/hooks/useMeFamily.ts
//
// React Query hook for the current user's linked player profiles, backed by
// GET /users/me/family. Profile-screen only; does not share the userPlayers.me
// cache used by the Home highlights widget / mobile.

import { useQuery } from '@tanstack/react-query'
import { queryKeys } from '@sportninja/common/config/queryKeys'
import {
  listMeFamily,
  type MeFamilyPlayer,
} from '@sportninja/common/services/user/listMeFamily'

const STALE_TIME = 5 * 60 * 1000

export const useMeFamily = (): {
  players: MeFamilyPlayer[]
  isLoading: boolean
  error: Error | null
  refetch: () => Promise<unknown>
} => {
  'use memo'
  const { data, isPending, isFetching, error, refetch } = useQuery({
    queryKey: queryKeys.userFamily.me(),
    queryFn: listMeFamily,
    staleTime: STALE_TIME,
  })

  return {
    players: data ?? [],
    isLoading: isPending || isFetching,
    error: (error as Error) ?? null,
    refetch,
  }
}
